<div class="modal fade show d-block" tabindex="-1" role="dialog" (click)="onBackdropClick($event)">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content rounded-4 shadow border-0">
      <div class="modal-header border-0 pb-0">
        <h5 class="modal-title d-flex align-items-center gap-2">
          <span class="material-symbols-outlined text-colonial">map</span>
          {{ isEditMode ? 'Renombrar región' : 'Nueva región' }}
        </h5>
        <button type="button" class="btn-close" aria-label="Cerrar" (click)="onCancel()"></button>
      </div>

      <div class="modal-body">
        <label class="form-label small" for="regionName">Nombre</label>
        <input id="regionName" type="text" class="form-control" [(ngModel)]="name"
          placeholder="Ej: Región Norte" (keyup.enter)="onSave()" />
      </div>

      <div class="modal-footer border-0">
        <button type="button" class="btn btn-outline-secondary" (click)="onCancel()">Cancelar</button>
        <button type="button" class="btn bg-colonial btn-secondary" (click)="onSave()"
          [disabled]="!canSave">{{ isEditMode ? 'Guardar' : 'Crear' }}</button>
      </div>
    </div>
  </div>
</div>
<div class="modal-backdrop fade show"></div>
